import { Injectable } from '@angular/core';

import { ILogger } from '@shure/shared/angular/utils/logging';
import { AnalyticsEvent } from '@shure/shared/models';

import { AnalyticsProvider } from '../models';

@Injectable()
export class NoopAnalyticsProvider extends AnalyticsProvider {
	private readonly logger: ILogger;

	constructor(logger: ILogger) {
		super();
		this.logger = logger.createScopedLogger('NoopAnalyticsProvider');
	}

	public optIn(): void {
		this.logger.information('optIn', 'User opted in to analytics');
	}

	public optOut(): void {
		this.logger.information('optOut', 'User opted out of analytics');
	}

	public trackEvent<T extends AnalyticsEvent>(event: T): void {
		this.logger.information('trackEvent', 'Event tracked', event);
	}
}
